export const SORT_DESKTOP_RELEVANCE_LABEL = 'sort_select.relevance';
export const SORT_PRICE = 'sort_select.price';
export const SORT_DESKTOP_PRICE_ASC_LABEL = 'sort_select.price_desktop_asc';
export const SORT_DESKTOP_PRICE_DESC_LABEL = 'sort_select.price_desktop_desc';
export const SORT_DRAWER_HEADER = 'sort.drawer_header';
export const SORT_BY = 'sort.sort_by';
